import React, { useState } from 'react';
import { LitterBinIcon, MoreVIcon, ShareIcon, WarningIcon } from 'tt-ui-lib/icons';
import { styled } from '@mui/material/styles';
import { Menu, IconButton } from '@mui/material';
import clsx from 'clsx';
import UserInfoMenuItem from './UserInfoMenuItem';
import styles from './UserInfoMenu.module.scss';
import { ShareModal } from '../../../../modules/tt-modals';
import DeleteUserModal from '../../../../components/Modals/DeleteUserModal';

const UserInfoMenu = ({ idButton, idMenu, isCurrentUser, ...restProps }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const share = () => {
    setShowShareModal(true);
    setAnchorEl(null);
  };

  const StyledMenu = styled((props) => (
    <Menu
      id="user-info-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'menu-button',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.08)',
      borderRadius: '12px',
      '& .MuiMenu-list': {},
    },
  }));

  return (
    <>
      <IconButton
        id="menu-button"
        className={clsx(styles.menuBtn, restProps?.btnClassName)}
        aria-controls={open ? 'user-info-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        type="button"
        onClick={handleClick}
      >
        <MoreVIcon className="icon-blue-fill" style={{ width: 24, height: 24, flexShrink: 0 }} />
      </IconButton>
      <StyledMenu>
        <UserInfoMenuItem
          onClick={() => share()}
          text="Share"
          Icon={ShareIcon}
          iconProps={{
            style: { width: 20, height: 20, flexShrink: 0 },
          }}
        />
        {isCurrentUser ? (
          <>
            <UserInfoMenuItem
              text="Delete"
              Icon={LitterBinIcon}
              iconProps={{
                className: 'icon-red-fill',
                style: { width: 20, height: 20, flexShrink: 0 },
              }}
              onClick={() => {
                setShowDeleteModal(true);
              }}
              isDelete
            />
            <DeleteUserModal open={showDeleteModal} setOpen={setShowDeleteModal} />
          </>
        ) : (
          <UserInfoMenuItem
            text="Report"
            Icon={WarningIcon}
            iconProps={{
              style: { width: 20, height: 20, flexShrink: 0 },
            }}
          />
        )}
      </StyledMenu>
      <ShareModal open={showShareModal} closeModal={() => setShowShareModal(false)} />
    </>
  );
};

export default UserInfoMenu;
